import React from 'react';

const About = () => {
  return (
    <section className="about__v4 section pt-3 pt-md-5" id="about">
      <div className="container">
        <div className="row">
          <div className="col-md-6 order-md-2 mt-3 mt-md-0">
            <div className="row justify-content-end">
              <div className="col-md-11 mb-4 mb-md-0">
                <span className="subtitle text-uppercase mb-3" data-aos="fade-up" data-aos-delay={0}>
                  About Our Passion
                </span>
                <h2 className="mb-4" data-aos="fade-up" data-aos-delay={100}>
                  Connecting Fans with the Spirit of Cricket
                </h2>
                <div data-aos="fade-up" data-aos-delay={200}>
                  <p>
                    We are a team of dedicated cricket enthusiasts committed to bringing fans closer to the game they love. From grassroots cricket to professional leagues, our goal is to celebrate the passion, discipline, and excitement that cricket inspires across generations.
                  </p>
                  <p>
                    Join us as we continue to support talent, promote sportsmanship, and grow the love for cricket — on and off the field.
                  </p>
                </div>
                <h4 className="small fw-bold mt-4 mb-3" data-aos="fade-up" data-aos-delay={300}>
                  Our Core Values
                </h4>
                <ul className="d-flex flex-row flex-wrap list-unstyled gap-3 features" data-aos="fade-up" data-aos-delay={400}>
                  <li className="d-flex align-items-center gap-2">
                    <span className="icon rounded-circle text-center">
                      <i className="bi bi-check" />
                    </span>
                    <span className="text">Cricket Academy Excellence</span>
                  </li>
                  <li className="d-flex align-items-center gap-2">
                    <span className="icon rounded-circle text-center">
                      <i className="bi bi-check" />
                    </span>
                    <span className="text">Youth Training &amp; Coaching</span>
                  </li>
                  <li className="d-flex align-items-center gap-2">
                    <span className="icon rounded-circle text-center">
                      <i className="bi bi-check" />
                    </span>
                    <span className="text">International Cricket Coverage</span>
                  </li>
                  <li className="d-flex align-items-center gap-2">
                    <span className="icon rounded-circle text-center">
                      <i className="bi bi-check" />
                    </span>
                    <span className="text">Continuous Innovation</span>
                  </li>
                  <li className="d-flex align-items-center gap-2">
                    <span className="icon rounded-circle text-center">
                      <i className="bi bi-check" />
                    </span>
                    <span className="text">Professional Sports Standards</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="img-wrap position-relative">
              <img className="img-fluid rounded-4" src="/assets/images/1713908866509.jpg" alt="About sports" data-aos="fade-up" data-aos-delay={0} />
              <div className="mission-statement p-4 rounded-4 d-flex gap-4" data-aos="fade-up" data-aos-delay={100}>
                <div className="mission-icon text-center rounded-circle">
                  <i className="bi bi-trophy fs-4" />
                </div>
                <div>
                  <h3 className="text-uppercase fw-bold">Our Goal</h3>
                  <p className="fs-5 mb-0">
                    To be the leading platform for sports fans, providing top-quality content and fostering a strong community.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
